import React from "react";
import Header from "./components/commons/Header";
import Footer from "./components/commons/Footer";
import {
    PAGE_SHOP_PROMOCODE,
    PAGE_REGISTRATION_THANK_YOU,
    PAGE_REGISTRATION_FAILED,
    PAGE_PROMO_CODE_FAILED,
    PAGE_SHOP,
    PAGE_SHOP_FAILED,
    PAGE_SHOP_THANK_YOU,
} from "./constants";
import Sidebar from "./components/commons/SideBar";
import {Navigate, Route, Routes} from "react-router-dom";
import InvalidPromoCode from "./components/InvalidPromoCode";
import ThankYouPage from "./components/ThankYouPage";
import ErrorPage from "./components/ErrorPage";
import ActivationSuccessPage from "./components/ActivationSuccessPage";
import {connect} from "react-redux";
import {isModalOpen} from "./selectors";
import {setModalOpenAction} from "./reducers";
import Form from "./components/Form";

const actionsToProps = dispatch => ({
    setModalOpen: payload => dispatch(setModalOpenAction(payload)),
});

const stateToProps = state => ({
    isModalOpen: isModalOpen(state),
});

const ShopRegistrationApp = props => {

    const setModalOpen = (isOpen) => {
        props.setModalOpen(isOpen);
    }

    const routes =
        <Routes>
            <Route path={PAGE_SHOP_PROMOCODE} element={<Form setModalOpen={setModalOpen} />} />
            <Route path={PAGE_PROMO_CODE_FAILED} element={<InvalidPromoCode />} />
            <Route path={PAGE_REGISTRATION_THANK_YOU} element={<ThankYouPage />} />
            <Route path={PAGE_REGISTRATION_FAILED} element={<ErrorPage />} />
            <Route path={PAGE_SHOP} element={<Form />} />
            <Route path={PAGE_SHOP_FAILED} element={<ErrorPage />} />
            <Route path={PAGE_SHOP_THANK_YOU} element={<ActivationSuccessPage />} />
            <Route path='*' element={<Navigate to={PAGE_SHOP_PROMOCODE} replace />} />
        </Routes>
    ;

    return (
        <div className={props.isModalOpen === true ? 'app modal-open' : 'app'}>
            <div id="wrapper" className="wrapper">
                <Header />

                <main>
                    <div className="container">
                        <div className="content">
                            <div>
                                <div className="headline-bar hidden-s">
                                    <p className="headline-bar--txt">Open an account</p>
                                </div>

                                <div className="content-main table">
                                    {routes}

                                    <div className="side-bar f0 pull-right hidden-s">
                                        <Sidebar />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </div>
    )
}

export default connect(
    stateToProps,
    actionsToProps
)(ShopRegistrationApp);
